import { useState, useEffect } from "react";
import { Layout, PageHero } from "../components/Layout";
import { Seo } from "../components/Seo";
import { PortfolioGrid, CTA } from "../components/Sections";
import { PROJECTS, PORTFOLIO_FILTERS } from "../data";
import api from "../lib/api";

const norm = (str) => (str || "").toLowerCase().replace(/[^a-z0-9]/g, "");

const EXCLUDED_PROJECT_SLUGS = ["woodwelt", "mycitydekho", "digital-india-rural-iot"];

export default function Portfolio() {
  const [filter, setFilter] = useState("All");
  const [projectList, setProjectList] = useState(() =>
    PROJECTS.filter((p) => !EXCLUDED_PROJECT_SLUGS.includes(p.slug))
  );

  useEffect(() => {
    api.get("/projects")
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setProjectList(() => {
            const merged = PROJECTS.filter((p) => !EXCLUDED_PROJECT_SLUGS.includes(p.slug));
            res.data.forEach((p) => {
              if (EXCLUDED_PROJECT_SLUGS.includes(p.slug)) return;
              if (p.slug === "launchpad") {
                p.img = "/brand/launchpad-preview.png";
                p.logo = p.logo || "/brand/launchpad-clean.png";
              } else if (p.slug === "php2shell") {
                p.img = "/brand/php2shell-preview.png";
                p.logo = p.logo || "/brand/php2shell-logo.png";
              } else if (p.slug === "latajcollection") {
                p.title = "latajcollection";
                p.logo = "/brand/latajcollection-logo.png";
              } else if (p.slug === "wordpress-security-hardening") {
                p.img = "/brand/wordpress-security-preview.png";
                p.logo = p.logo || "/brand/wordpress-security-logo.png";
              }
              const idx = merged.findIndex((m) => m.slug === p.slug);
              if (idx >= 0) merged[idx] = { ...merged[idx], ...p };
              else merged.push(p);
            });
            return merged.filter((p) => !EXCLUDED_PROJECT_SLUGS.includes(p.slug));
          });
        }
      })
      .catch(() => {});
  }, []);

  const items = filter === "All"
    ? projectList
    : projectList.filter((p) => {
        const pSector = norm(p.sector || p.industry || "");
        const target = norm(filter);
        if (target === "b2bindustry") {
          return pSector === "b2bindustry" || pSector === "b2b";
        }
        if (target === "artsculture") {
          return pSector === "artsculture" || pSector.includes("art");
        }
        return pSector === target;
      });

  return (
    <Layout>
      <Seo title="Portfolio - Our Work & Case Studies" description="Explore Neuravolt's portfolio of industry solutions, client impact, and digital transformation projects across healthcare, retail, manufacturing, logistics, and more." keywords="Neuravolt portfolio, industry case studies, software development projects, digital transformation work India" path="/portfolio" />
      <PageHero title="Work we're proud of" sub="Real products and solutions we've designed, built and scaled across industries." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-14 -mb-10">
        <div className="flex items-center gap-1.5 lg:gap-2 overflow-x-auto scrollbar-none py-2 -my-2 flex-nowrap">
          {PORTFOLIO_FILTERS.map((f) => (
            <button
              key={f}
              data-testid={`filter-${f.toLowerCase().replace(/[\s&]+/g, "-")}`}
              onClick={() => setFilter(f)}
              className={`shrink-0 px-2.5 sm:px-3 lg:px-3.5 py-1.5 sm:py-1.5 lg:py-2 rounded-full text-xs sm:text-[13px] font-medium whitespace-nowrap transition-all duration-200 ${
                filter === f
                  ? "bg-[#FF5A1F] text-white shadow-sm shadow-[#FF5A1F]/30 font-semibold"
                  : "bg-white border border-black/[0.08] text-neutral-600 hover:text-[#FF5A1F] hover:border-[#FF5A1F]/30 hover:bg-white shadow-[0_1px_2px_rgba(0,0,0,0.03)]"
              }`}
            >
              {f}
            </button>
          ))}
        </div>
      </div>
      {items.length ? <PortfolioGrid items={items} heading={false} />
        : <div className="max-w-7xl mx-auto px-5 sm:px-8 py-28 text-center text-neutral-400">No projects in this industry yet. Coming soon.</div>}

      <CTA />
    </Layout>
  );
}
